
import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import {
    ComponentContextService, DataFormBase, EventData
} from 'tnx-shared';

@Component({
    selector: 'faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
    providers: [ComponentContextService],
})
export class FaqComponent extends DataFormBase implements OnInit {
    constructor(
        protected _injector: Injector,
    ) {
        super(_injector);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    async onFormInitialized(formEvent: EventData) {
        // tiền xử lý dữ liệu (ví dụ tổng hợp datasource), trước khi gọi api get detail
    }

    async onFormEvent(evt) {
        // các event trong form
        console.log(evt);
    }

    async modifyDetailData(data) {
        // xử lý dữ liệu lấy từ get detail về
        // if (data.idCoCauToChuc)
        //     this.coCauToChucForm.changeDataSource(data.idCoCauToChuc);
    }

    async onAfterGetDetail() {
        // xử lý dữ liệu sau khi đã lấy từ api (sau cả event modifyDetailData) về và trước khi hiển thị ra view
    }
}

